$(window).on('load scroll resize',function(){

  var windowHeight = $(window).height();
  var headerPos = $('.header').offset().top;
  var resultPos = $('.header_search_result').offset().top;
  var resultDistance = resultPos - headerPos;
  var changeHeight = windowHeight - resultDistance - 10;

  $('.header_search_result').css('max-height',changeHeight+'px');

});


$(function(){
  $('.header_search_submit').click(function(){
    if ($(".header_search_word").empty()) {
      window.location.href = 'https://www.fumo-collection.com/collections/all';
    }
  });

  // Show search results when typing
  $('.header_search_word').on('input focus', function() {
    if ($(this).val().length > 0) {
      $('.header_search_result').show();
    }
  });

  // Hide search results when clicking outside
  $(document).on('click', function(e) {
    if (!$(e.target).closest('.header_search').length) {
      $('.header_search_result').hide();
    }
  });

  // Hide search results on escape key
  $(document).on('keydown', function(e) {
    if (e.key === 'Escape') {
      $('.header_search_result').hide();
      $('.header_search_word').blur();
    }
  });
});
